<template>
    <div class="guest-actions">
        <!-- Desktop Guest Actions -->
        <div v-if="$vuetify.breakpoint.smAndUp" class="d-flex align-center">
            <v-btn
                v-if="$page.props.currentRouteName !== 'login'"
                :href="`/login?redirect=${redirect}`"
                elevation="0"
                text
                class="ml-2"
                :disabled="loading"
            >
                Login
            </v-btn>

            <v-btn
                v-if="$page.props.currentRouteName !== 'register'"
                href="/register"
                elevation="0"
                outlined
                color="primary"
                class="ml-2"
                :disabled="loading"
            >
                Register
            </v-btn>
        </div>

        <!-- Mobile Guest Menu -->
        <v-menu v-if="$vuetify.breakpoint.xsOnly" offset-y :eager="true">
            <template #activator="{ on, attrs }">
                <v-btn text
                       v-bind="attrs"
                       v-on="on"
                       small
                       class="guest-menu-btn"
                       :disabled="loading"
                >
                    <v-icon small>mdi-account-outline</v-icon>
                </v-btn>
            </template>

            <v-list dense>
                <v-list-item v-if="$page.props.currentRouteName !== 'login'" :href="`/login?redirect=${redirect}`">
                    <v-list-item-icon>
                        <v-icon small>mdi-login</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Login</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="$page.props.currentRouteName !== 'register'" href="/register">
                    <v-list-item-icon>
                        <v-icon small>mdi-account-plus</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Register</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: 'GuestActions',

    props: {
        theme: {
            type: String,
            required: true,
            default: 'system',
        },
        showThemeToggle: {
            type: Boolean,
            default: true,
        },
    },

    emits: ['toggle-theme'],

    data() {
        return {
            loading: false,
            cachedRedirect: '',
        };
    },

    validations: {
        theme: {
            required: true,
            validator: value => ['light', 'dark', 'system'].includes(value),
        },
    },

    computed: {
        redirect() {
            if (this.cachedRedirect) {
                return this.cachedRedirect;
            }

            let redirect = '';
            if (
                window.location.pathname === '/' ||
                window.location.pathname === '/login' ||
                window.location.pathname === '/register'
            ) {
                redirect = '';
            } else {
                redirect = window.location.pathname + window.location.search;
            }

            this.cachedRedirect = redirect;
            return redirect;
        },
    },

    methods: {
        toggleDarkTheme() {
            this.$emit('toggle-theme');
        },
    },

    watch: {
        $route: {
            handler() {
                this.cachedRedirect = '';
            },
        },
    },
};
</script>

<style scoped>
.guest-actions {
    display: flex;
    align-items: center;
    margin-left: auto;
}

.guest-menu-btn {
    min-width: 0;
    padding: 0 8px !important;
    border-radius: 20px;
    transition: background-color 0.2s ease;
}

@media (max-width: 600px) {
    .guest-actions {
        margin-left: auto;
        margin-right: 0;
    }
}
</style>
